import React from "react";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import {
  CLEARANCE_AGENTS_URL,
  DELETE_CLEARANCE_AGENT,
  SAVE_CLEARANCE_AGENT,
} from "../../../API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import ItemValidationSchema from "@Utils/Validations/ItemValidationSchema";

function ClearanceAgentsListing() {
  const attributes = [{ key: "agentName", label: "Agent Name", flex: 2 }];

  const validationSchema = ItemValidationSchema(attributes[0].key,attributes[0].label);

  return (
    <GenericItemsListing
      items_URL={CLEARANCE_AGENTS_URL}
      SAVE_Item={SAVE_CLEARANCE_AGENT}
      DELETE_Item={DELETE_CLEARANCE_AGENT}
      title="Clearance Agents"
      name="Agent"
      icon={<AssignmentIndRoundedIcon fontSize="large" color="white" />}
      attributes={attributes}
      validationSchema={validationSchema}
      uniqueId={"agentId"}
      isClearanceAgent={true}
    />
  );
}

export default ClearanceAgentsListing;
